var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIconOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69571 4.80288C4.7158 4.80288 3.77599 5.19205 3.08295 5.88482C2.38991 6.5776 2.00038 7.51725 2 8.49716L2 18.3057C2 18.791 2.0956 19.2715 2.28135 19.7198C2.46709 20.1681 2.73934 20.5754 3.08254 20.9185C3.42573 21.2616 3.83316 21.5336 4.28153 21.7192C4.72991 21.9048 5.21045 22.0002 5.69571 22H15.5029C16.4828 21.9996 17.4224 21.6101 18.1152 20.9171C18.808 20.224 19.1971 19.2842 19.1971 18.3043V12.7C19.1971 12.4632 19.1031 12.2361 18.9356 12.0687C18.7682 11.9012 18.5411 11.8072 18.3043 11.8072C18.0675 11.8072 17.8404 11.9012 17.6729 12.0687C17.5055 12.2361 17.4114 12.4632 17.4114 12.7V18.3043C17.4114 18.8106 17.2104 19.2962 16.8525 19.6544C16.4946 20.0125 16.0092 20.2139 15.5029 20.2143H5.69571C5.44484 20.2145 5.19638 20.1652 4.96457 20.0693C4.73275 19.9734 4.52212 19.8327 4.34472 19.6553C4.16732 19.4779 4.02664 19.2673 3.93072 19.0355C3.8348 18.8036 3.78553 18.5552 3.78571 18.3043V8.49716C3.78609 7.99085 3.98749 7.5054 4.34565 7.14751C4.7038 6.78963 5.1894 6.58859 5.69571 6.58859H11.3C11.5368 6.58859 11.7639 6.49452 11.9313 6.32708C12.0988 6.15964 12.1929 5.93254 12.1929 5.69574C12.1929 5.45894 12.0988 5.23183 11.9313 5.06439C11.7639 4.89695 11.5368 4.80288 11.3 4.80288H5.69571Z",
    fill: "#5C6B3C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 5.75,
    r: 3.75,
    fill: "#FF6347"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconOn);
export default __webpack_public_path__ + "static/media/Notification Icon On.fc33e9a14817a3c8018a53e6659fb89c.svg";
export { ForwardRef as ReactComponent };